import pl from "@locales/settings/pl.json";
import en from "@locales/settings/en.json";

export default {
  pl: pl,
  en: en,
};
